(function () {
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTile(tile, autoplayEnabled) {
    var video = tile.querySelector('video');
    var progressBar = tile.querySelector('[data-video-progress]');
    if (!video) return;

    video.muted = true;
    video.setAttribute('muted', '');
    tile.setAttribute('data-playing', 'false');

    function play() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            tile.setAttribute('data-playing', 'true');
          })
          .catch(function () {
            // Autoplay was blocked; leave the play icon visible so the
            // shopper can tap to start playback manually.
            tile.setAttribute('data-playing', 'false');
          });
      } else {
        tile.setAttribute('data-playing', 'true');
      }
    }

    function pause() {
      video.pause();
      tile.setAttribute('data-playing', 'false');
    }

    tile.addEventListener('click', function (event) {
      if (event.target.closest('a')) return;
      if (video.paused) {
        play();
      } else {
        pause();
      }
    });

    if (progressBar) {
      video.addEventListener('timeupdate', function () {
        if (video.duration) {
          progressBar.style.width = (video.currentTime / video.duration) * 100 + '%';
        }
      });
    }

    if (autoplayEnabled && !prefersReducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              play();
            } else {
              pause();
            }
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      observer.observe(tile);
      tile._vcObserver = observer;
    }
  }

  function initSection(section) {
    if (section._vcInitialized) return;
    section._vcInitialized = true;

    var track = section.querySelector('[data-vc-track]');
    if (!track) return;

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var tiles = Array.prototype.slice.call(section.querySelectorAll('[data-video-tile]'));
    tiles.forEach(function (tile) {
      initTile(tile, autoplayEnabled);
    });

    var prevBtn = section.querySelector('[data-vc-prev]');
    var nextBtn = section.querySelector('[data-vc-next]');

    function scrollByDirection(direction) {
      var slide = track.querySelector('.vc-slide');
      var amount = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDirection(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDirection(1); });
  }

  function teardownSection(section) {
    var tiles = section.querySelectorAll('[data-video-tile]');
    tiles.forEach(function (tile) {
      if (tile._vcObserver) {
        tile._vcObserver.disconnect();
        tile._vcObserver = null;
      }
    });
    section._vcInitialized = false;
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-video-carousel]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when a merchant adds/reorders this section in the theme editor,
  // and tear down observers when it's removed to avoid leaks.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-video-carousel]');
    if (section) teardownSection(section);
  });
})();